import React, { Component } from "react";

import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutTheme,
  changeLayoutWidth,
  verify_admin
} from "../../store/actions";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Rightbar from "../CommonForBoth/Rightbar";
import withRouter from "../Common/withRouter";
import LoadingDialog from "../Common/LoadingDialog";
import Notification from "../../components/Common/Notification";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      showSearch: false,
      inputFocus: false,
      notification: {
        open: false,
        msg: "",
        type: "success",
      }
    };
    this.toggleMenuCallback = this.toggleMenuCallback.bind(this);
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this);
    this.layout = React.createRef();

  }

  toggleRightSidebar() {
    this.props.toggleRightSidebar();
  }

  capitalizeFirstLetter = string => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.isPreloader === true) {
        document.getElementById('preloader').style.display = "block";
        document.getElementById('status').style.display = "block";

        setTimeout(function () {

          document.getElementById('preloader').style.display = "none";
          document.getElementById('status').style.display = "none";

        }, 2500);
      }
      else {
        document.getElementById('preloader').style.display = "none";
        document.getElementById('status').style.display = "none";
      }
    }

    if (prevProps.router.location.pathname !== this.props.router.location.pathname) {
      // Scroll Top to 0
      window.scrollTo(0, 0);

      let currentage = this.capitalizeFirstLetter(this.props.router.location.pathname);

      currentage = currentage.replaceAll("-", " ");
      currentage = currentage.split('/')[0];

      document.title =
        currentage + " | Aspeed Admin Portal";

      if (this.props.leftSideBarTheme) {
        this.props.changeSidebarTheme(this.props.leftSideBarTheme);
      }

      if (this.props.layoutWidth) {
        this.props.changeLayoutWidth(this.props.layoutWidth);
      }

      if (this.props.leftSideBarType) {
        this.props.changeSidebarType(this.props.leftSideBarType);
      }
      if (this.props.topbarTheme) {
        this.props.changeTopbarTheme(this.props.topbarTheme);
      }
      if (this.props.theme) {
        this.props.changeLayoutTheme(this.props.theme);
      }

      if (this.props.showRightSidebar) {
        this.toggleRightSidebar();
      }
    }

    if (prevProps?.error !== this.props?.error) {
      if (this.props.error?.code === "network_error") {
        this.setState({
          notification: {
            open: true,
            msg: "Network response error, please try again later",
            type: "error"
          }
        });
      }
    }
  }

  componentDidMount() {


    // Scroll Top to 0
    window.scrollTo(0, 0);

    this.props.verify_admin();

    let currentage = this.capitalizeFirstLetter(this.props.router.location.pathname);

    currentage = currentage.replaceAll("-", " ");
    currentage = currentage.split('/')[0];

    document.title =
      currentage + " | Aspeed Admin Portal";

    if (this.props.leftSideBarTheme) {
      this.props.changeSidebarTheme(this.props.leftSideBarTheme);
    }

    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth);
    }

    if (this.props.leftSideBarType) {
      this.props.changeSidebarType(this.props.leftSideBarType);
    }
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme);
    }
    if (this.props.theme) {
      this.props.changeLayoutTheme(this.props.theme);
    }

    if (this.props.showRightSidebar) {
      this.toggleRightSidebar();
    }
  }

  toggleMenuCallback = () => {
    if (this.props.leftSideBarType === "default") {
      this.props.changeSidebarType("condensed", this.state.isMobile);
    } else if (this.props.leftSideBarType === "condensed") {
      this.props.changeSidebarType("default", this.state.isMobile);
    }
  };

  render() {
    return (
      <React.Fragment>
        <Notification notification={this.state.notification} setNotification={(e) => this.setState({ notification: e })} />
        <div id="preloader">
          <div id="status">
            <div className="spinner">
              <i className="ri-loader-line spin-icon"></i>
            </div>
          </div>
        </div>
        {
          this.props.verifyAdmin?.user?.code ?
            <>
              <Header toggleMenuCallback={this.toggleMenuCallback} toggleRightSidebar={this.toggleRightSidebar} />
              <Sidebar
                theme={this.props.leftSideBarTheme}
                type={this.props.leftSideBarType}
                isMobile={this.state.isMobile}
              />
              <div className="main-content" ref={this.layout} >
                {this.props.children}
                {/* <Footer /> */}
              </div>
              <Rightbar />
            </> : <LoadingDialog open={true} />
        }
      </React.Fragment>
    );
  }
}


const mapStatetoProps = state => {
  return {
    ...state.Layout,
    verifyAdmin: state.Login.verifyAdmin,
    error: (state?.Banner?.error?.length !== 0 && state?.Banner?.error) ||( state?.Category?.error?.length !== 0 && state?.Category?.error) || (state?.Configuration?.error?.length !== 0 && state?.Configuration?.error) || (state?.Dashboard?.error?.length !== 0 && state?.Dashboard?.error) || (state?.Customer?.error?.length !== 0 && state?.Customer?.error) || (state?.Inventory?.error?.length !== 0 && state?.Inventory?.error) || (state?.Manufacturer?.error?.length !== 0 && state?.Manufacturer?.error)
      || (state?.Model?.error?.length !== 0 && state?.Model?.error )|| (state?.General?.error?.length !== 0 && state?.General?.error) || (state?.Order?.error?.length !== 0 && state?.Order?.error) || (state?.Payment?.error?.length !== 0 && state?.Payment?.error) || (state?.Permission?.error?.length !== 0 && state?.Permission?.error) || (state?.Profile?.error?.length !== 0 && state?.Profile?.error) || (state?.Product?.error?.length !== 0 && state?.Product?.error) 
      || (state?.Promocode?.error?.length !== 0 && state?.Promocode?.error) || (state?.Role?.error?.length !== 0 && state?.Role?.error) || (state?.User?.error?.length !== 0 && state?.User?.error) || (state?.Report?.error?.length !== 0 && state?.Report?.error) || (state?.Review?.error?.length !== 0 && state?.Review?.error)|| (state?.Service?.error?.length !== 0 && state?.Service?.error) || (state?.ServiceType?.error?.length !== 0 && state?.ServiceType?.error)
      || (state?.Setting?.error?.length !== 0 && state?.Setting?.error)|| (state?.Shipping?.error?.length !== 0 && state?.Shipping?.error) || (state?.ShippingRate?.error?.length !== 0 && state?.ShippingRate?.error)|| (state?.Support?.error?.length !== 0 && state?.Support?.error)|| (state?.Voucher?.error?.length !== 0 && state?.Voucher?.error),
  };
};
export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutTheme,
  changeLayoutWidth,
  verify_admin
})(withRouter(Layout));

